module.exports = __webpack_public_path__ + "img/3-5.a2b39a23.svg";